import {
  type PayloadAction,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import type { RootState } from 'app/store';
import type {
  UploadItem,
  UploadStatusListItem,
  UploadWidgetState,
} from './types';

export const initialUploadWidgetState: UploadWidgetState = {
  isFilesUploadWidgetOpen: false,
  filesToUpload: [],
  uploadStatusList: [],
  completedFilesCount: 0,
};

export const uploadWidgetSlice = createSlice({
  name: 'uploadWidget',
  initialState: initialUploadWidgetState,
  reducers: {
    setIsFilesUploadWidgetOpen: (state, action: PayloadAction<boolean>) => {
      state.isFilesUploadWidgetOpen = action.payload;
    },
    setFilesToUpload: (state, action: PayloadAction<UploadItem[]>) => {
      state.filesToUpload = action.payload;
    },
    addFilesToUpload: (state, action: PayloadAction<UploadItem[]>) => {
      state.filesToUpload.push(...action.payload);
    },
    setUploadStatusList: (
      state,
      action: PayloadAction<
        (uploadStatusList: UploadStatusListItem[]) => UploadStatusListItem[]
      >,
    ) => {
      state.uploadStatusList = action.payload(state.uploadStatusList);
    },

    setCompletedFilesCount: (state, action: PayloadAction<any>) => {
      state.completedFilesCount = action.payload;
    },
    resetUploadWidget: (state) => {
      Object.assign(state, initialUploadWidgetState);
    },
  },
});

// Actions.
export const {
  setIsFilesUploadWidgetOpen,
  setFilesToUpload,
  addFilesToUpload,
  setUploadStatusList,
  setCompletedFilesCount,
  resetUploadWidget,
} = uploadWidgetSlice.actions;

// Selectors.
export const selectUploadWidget = (state: RootState) => state.uploadWidget;

export const selectCompletedFilesCount = createSelector(
  (state: RootState) => state.uploadWidget,
  (uploadWidget) => uploadWidget.completedFilesCount,
);

// Reducers.
export const uploadWidgetReducer = uploadWidgetSlice.reducer;
